import React from "react";
import InvoiceField from "../component/InvoiceFiled";

const ContractorForm = ({ data = {}, onUpdate = () => {}, onSave = () => {} }) => {

  const handleSave = () => {
    onSave(data);
  };

  const updateItem = (index, key, value) => {
    const rows = [...(data.items || [])];
    rows[index] = { ...rows[index], [key]: value };
    onUpdate("items", rows);
  };

  const addItem = () => {
    const rows = [
      ...(data.items || []),
      { name: "", desc: "", qty: "", rate: "", amount: "" }
    ];
    onUpdate("items", rows);
  };

  const removeItem = (index) => {
    const rows = [...(data.items || [])];
    rows.splice(index, 1);
    onUpdate("items", rows);
  };

  return (
    <div className="space-y-6">

      <h3 className="font-bold text-lg text-yellow-600 border-b pb-2">
        Contractor & Project Info
      </h3>

      <InvoiceField
        label="Project Name *"
        value={data.projectName || ""}
        onChange={(v) => onUpdate("projectName", v)}
        required
      />

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="GST Number *"
          type="gst"
          value={data.gstNumber || ""}
          onChange={(v) => onUpdate("gstNumber", v)}
          maxLength={15}
          required
        />
        <InvoiceField
          label="PAN Card *"
          type="pancard"
          value={data.panNumber || ""}
          onChange={(v) => onUpdate("panNumber", v)}
          maxLength={10}
          required
        />
      </div>

      <div className="grid grid-cols-2 gap-4">
        <InvoiceField
          label="Shipping Charge"
          type="number"
          value={data.shipping || ""}
          onChange={(v) => onUpdate("shipping", v)}
        />
        <InvoiceField
          label="Advance Paid"
          type="number"
          value={data.advance || ""}
          onChange={(v) => onUpdate("advance", v)}
        />
      </div>

      <InvoiceField
        label="Terms *"
        type="dropdown"
        options={["Due on Receipt", "Net 30", "Net 60"]}
        value={data.terms || ""}
        onChange={(v) => onUpdate("terms", v)}
        required
      />

      <div className="border-t pt-4">
        <h4 className="text-sm font-bold text-gray-500 mb-2 uppercase">
          Line Items
        </h4>

        {(data.items || []).map((item, index) => (
          <div key={index} className="grid grid-cols-5 gap-2 mb-2 items-end">
            <InvoiceField
              label="Item Name *"
              value={item.name || ""}
              onChange={(v) => updateItem(index, "name", v)}
              required
            />
            <InvoiceField
              label="Description"
              value={item.desc || ""}
              onChange={(v) => updateItem(index, "desc", v)}
            />
            <InvoiceField
              label="Qty *"
              type="number"
              value={item.qty || ""}
              onChange={(v) => updateItem(index, "qty", v)}
              required
            />
            <InvoiceField
              label="Rate *"
              type="number"
              value={item.rate || ""}
              onChange={(v) => updateItem(index, "rate", v)}
              required
            />
            <InvoiceField
              label="Amount"
              type="number"
              value={item.amount || ""}
              onChange={(v) => updateItem(index, "amount", v)}
              disabled
            />

            <button
              type="button"
              onClick={() => removeItem(index)}
              className="text-red-500 text-xs"
            >
              Remove
            </button>
          </div>
        ))}

        <button
          type="button"
          onClick={addItem}
          className="text-yellow-600 text-sm mt-2"
        >
          + Add Item
        </button>
      </div>

      <div className="flex justify-end pt-4 border-t">
        <button
          type="button"
          onClick={handleSave}
          className="bg-yellow-600 text-white px-6 py-2 rounded-md hover:opacity-90"
        >
          Save Contractor Invoice
        </button>
      </div>

    </div>
  );
};

export default ContractorForm;
